// eslint-disable-next-line import/no-unresolved
import appConfig from 'app-config';
import _ from 'lodash';
import moment from 'moment';
import { SgProductService } from 'saga-modules';

const { sbaPrice } = appConfig;
const isMotorhome = SgProductService.isMotorHome();

const isSameOrAfterEffectiveDate = (csd) => {
    return moment(csd).isSameOrAfter(appConfig.sbaPrice.effectiveDate, 'day');
};

const sortSBACoverages = (data) => {
    data.sort((a, b) => {
        if (a.price === b.price) {
            if (a.name > b.name) return 1;
            if (a.name < b.name) return -1;
        }
        return parseFloat(a.price) - parseFloat(b.price);
    });
    return data;
};

const SBACoveragesPriceOverride = (csd, coverages, shouldCheckEffectiveDate, addon) => {
    coverages.forEach((cover) => {
        const { coverLevel } = cover;
        if (shouldCheckEffectiveDate) {
            const breakdownPrice = isMotorhome ? sbaPrice.motorHome : sbaPrice.motor;
            if (isSameOrAfterEffectiveDate(csd)) {
                _.set(cover, 'price', breakdownPrice.newPrice[coverLevel]);
            } else {
                _.set(cover, 'price', breakdownPrice.oldPrice[coverLevel]);
            }
        } else {
            const addonOption = addon.terms[0].options.find((option) => option.code === coverLevel);
            _.set(cover, 'price', addonOption.amount.amount.toFixed(2));
        }
    });
    return sortSBACoverages(coverages);
};

export default {
    SBACoveragesPriceOverride
};
